const prefix = "fas";
const iconName = "filter";
const width = 512;
const height = 512;
const unicode = "f0b0";
const svgPathData = "M504.6 84.19L320 306.8v149.2c0 19.52-21.97 30.7-37.75 19.66l-80-55.98C195.8 415.2 192 407.8 192 400V306.8L7.375 84.19C-9.965 63.28 5.213 32 32.7 32h446.6C506.8 32 521.1 63.28 504.6 84.19z";
export const faFilter = {
    prefix,
    iconName,
    icon: [width, height, [], unicode, svgPathData],
};
